import { TaskState } from 'models/tasks/taskHelperClasses';
import IdListDTO from '../IdListDTO';

export class Widget73DTO {
  tenants: IdListDTO;

  filter?: string;

  results?: Widget73ResultDTO[];

  constructor() {
    this.tenants = new IdListDTO([]);
  }
}

export class Widget73ResultDTO {
  tenantId: string;

  data: TaskState[];

  constructor() {
    this.tenantId = '';
    this.data = [];
  }
}
